import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
  RichTextInputToolbar,
} from "ra-input-rich-text";
import * as React from "react";
import {
  ArrayInput,
  Edit,
  EditProps,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";
import { StoredImage } from "../../../types";

const AboutEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="sectionImage"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="sectionImage"
          format={(value: StoredImage) => {
            if (!value) return [];
            if (typeof value === "string")
              return [
                {
                  src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value}`,
                },
              ];
            return value;
          }}
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="sectionTitle" label="about.title" />

          <TextInput
            fullWidth
            source="sectionSubtitle"
            label="about.subtitle"
          />
          <RichTextInput
            toolbar={
              <RichTextInputToolbar>
                <LevelSelect />
                <FormatButtons />
                <ListButtons />
                <LinkButtons />
                <QuoteButtons />
                <ClearButtons />
              </RichTextInputToolbar>
            }
            fullWidth
            source="sectionDescription"
            label="about.description"
          />

          <ArrayInput label="about.companyInfo" source="companyInfo">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="title" label="about.optionTitle" />
              <TextInput
                fullWidth
                source="description"
                label="about.optionDescription"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Edit>
  );
};

export default AboutEdit;
